import gql from 'graphql-tag'

export const createDownload = gql`mutation ($tempo: Int!, $key: String!) {
  createDownload(tempo: $tempo, key: $key) {
    url   
  }
}`

export default createDownload
